import { useContext } from 'react';

import { AuthProviderContext } from './AuthProviderContext';

export const useAuthProviderContext = () => {
  return useContext(AuthProviderContext);
};
